import { getToken } from '../_helpers/commonFunctions';
import call from './apiRequest';
import apiEndpoints from './apiEndpoints';

/**
 * Api call for updating deficiency details
 * @param {object} dataObject
 * @param {string} deficiencyId
 */
export const updateDeficiencyDetails = (dataObject, deficiencyId) =>
  call({
    method: 'put',
    endpoint: apiEndpoints.deficiency.concat('/', deficiencyId),
    payload: dataObject,
    authKey: getToken(),
  });

/**
 * Api call for getting deficiency details
 * @param {string} deficiencyId
 */
export const getDeficiencyDetails = (deficiencyId) =>
  call({
    method: 'get',
    endpoint: apiEndpoints.deficiency.concat('/', deficiencyId),
    authKey: getToken(),
  });

export const deleteDeficiency = (deficiencyId) =>
  call({
    method: 'delete',
    endpoint: apiEndpoints.deficiency.concat('/', deficiencyId),
    authKey: getToken(),
  });

/**
 * Api call for sending email
 * @param {string} reportCategory
 * @param {string} createdFor
 * @param {string} createdForName
 * @param {string} reportType
 * @param {string} deficiencyId
 * @param {Array} parts
 * @param {Array} labours
 */
export const sendEmail = (
  reportCategory,
  createdFor,
  createdForName,
  reportType,
  deficiencyId,
  parts,
  labours,
  description,
  ...rest
) => {
  const term = [...rest];
  let payload = {
    reportCategory,
    createdFor,
    createdForName,
    reportType,
    deficiencyId,
    parts,
    labours,
  };
  if (description) {
    payload.jobDetails = {
      description,
    };
  }
  if (term[0] && term[0].terms) {
    payload = {
      ...payload,
      jobDetails: {
        ...payload.jobDetails,
        ...term[0],
      },
    };
  }
  return call({
    method: 'put',
    endpoint: apiEndpoints.jobReport,
    payload,
    authKey: getToken(),
  });
};

/**
 * Api call to create new job
 * @param {string} description
 * @param {string} jobDate
 * @param {string} type
 * @param {string} reportCategory
 * @param {string} createdFor
 * @param {string} deficiencyId
 * @param {string} invoiceNo
 * @param {string} poNumber
 */
export const createNewJob = (
  description,
  jobDate,
  type,
  reportCategory,
  createdFor,
  deficiencyId,
  invoiceNo,
  poNumber
) => {
  const payload = {
    description,
    jobDate,
    type,
    reportCategory,
    createdFor,
    deficiencyId,
  };
  if (invoiceNo) {
    payload.invoiceNo = invoiceNo;
  }
  if (poNumber) {
    payload.poNumber = poNumber;
  }
  return call({
    method: 'post',
    endpoint: apiEndpoints.jobs,
    payload,
    authKey: getToken(),
  });
};
